import { pageLoadingStatusMixin } from 'relapp-loading';
import VpsApi from '../services/api/vps.js';
import { apiMixin } from 'relapp-api';

export default {
    mixins: [pageLoadingStatusMixin, apiMixin],
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            servers: null
        };
    },
    methods: {
        /**
         * Get the VPS list.
         */
        getVps(domain) {
            VpsApi.get(domain, true)
                .then(response => {
                    this.finishLoading();
                    this.servers = response.data;
                })
                .catch(error => {
                    this.finishLoading();
                });
        }
    }
};
